class ApplicationNavigation {
	id = null;
	application_id = null;
	seafarer_navigation_type_id = null;
	entity_name = '';
	rank_id = null;
	maritime_object_name = '';
	signed_on = null;
	signed_off = null;
	duration = '0';
	vessel_type_id = null;
	dwt = '';
	gt = '';
	engine_type_id = null;
	kw = '';
	dp_manufacturer_id = null;
	dp_type_id = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default ApplicationNavigation;
